import type { ReactNode } from 'react';
import Modal from 'react-modal';

import { Close } from '@shared/assets';
import { Card, IconButton } from '@shared/ui';

import * as st from './styles.module.scss';


interface Props {
    isOpen: boolean;
    onClose: () => void;
    children?: ReactNode;
}


export const SelectVideoModal = ({ isOpen, onClose, children }: Props): JSX.Element => {
    return (
        <Modal
            isOpen={isOpen}
            className={st.viewer}
            overlayClassName={st.overlay}
            onRequestClose={onClose}
        >
            <Card className={st.modal}>
                <div className={st.modal__header}>
                    <IconButton onClick={onClose} variant='white' className={st.close}>
                        <Close />
                    </IconButton>
                    <span className={st.title}>Добавить видео</span>
                </div>
                <p className={st.subtitle}>Откуда вы хотите добавить видео?</p>
                <ul className={st.list}>
                    {children}
                </ul>
            </Card>
        </Modal>
    );
}
